/**
 * magiczoom-a11y.js
 *
 * Standalone, build-free accessibility normalizer for the vendored MagicZoom
 * Plus gallery (assets/magiczoomplus.js). The vendor and the production
 * MagicToolbox app ScriptTag inject DOM at runtime that fails WAVE:
 *   - 1x1 base64 GIF positioning spacers with no alt attribute
 *   - duplicate/decorative <img> inside MagicToolbox containers with no alt
 *   - thumb prev/next <button> elements with no accessible name
 *
 * This script runs entirely client-side (no webpack, no build step). It only
 * ADDS attributes when they are absent, so it is idempotent and safe to run
 * repeatedly from a MutationObserver without triggering feedback loops. Every
 * path is wrapped in try/catch so a failure can never break the gallery.
 *
 * Server-side rendered content imgs already carry alt (see
 * snippets/magiczoomplus.liquid) — this only touches runtime-injected nodes.
 */
(function () {
  'use strict';

  var SPACER_PREFIX = 'data:image/gif;base64,R0lGODlh';
  var MT_CONTAINER_SELECTOR =
    '.MagicToolboxContainer, .mz-expand, .MagicScroll, [class*="magic-thumbs"]';

  function normalize() {
    try {
      // 1x1 base64 GIF positioning spacers: mark decorative + hidden.
      var imgs = document.getElementsByTagName('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var src = img.getAttribute('src') || '';
        if (src.indexOf(SPACER_PREFIX) === 0 && !img.hasAttribute('alt')) {
          img.setAttribute('alt', '');
          if (!img.hasAttribute('aria-hidden')) {
            img.setAttribute('aria-hidden', 'true');
          }
        }
      }

      // Any alt-less img inside a MagicToolbox container is a duplicate of
      // decorative/positioning media — the real content imgs get alt server-side.
      var containers = document.querySelectorAll(MT_CONTAINER_SELECTOR);
      for (var c = 0; c < containers.length; c++) {
        var inner = containers[c].getElementsByTagName('img');
        for (var j = 0; j < inner.length; j++) {
          if (!inner[j].hasAttribute('alt')) {
            inner[j].setAttribute('alt', '');
          }
        }
      }

      // Thumb navigation buttons injected by the MagicToolbox app ScriptTag.
      var buttons = document.querySelectorAll('.magic-thumbs-button');
      for (var b = 0; b < buttons.length; b++) {
        var btn = buttons[b];
        if (btn.hasAttribute('aria-label')) continue;
        var text = (btn.textContent || '').replace(/\s+/g, '');
        if (btn.className.indexOf('magic-thumbs-button-prev') !== -1) {
          btn.setAttribute('aria-label', 'Previous image');
        } else if (btn.className.indexOf('magic-thumbs-button-next') !== -1) {
          btn.setAttribute('aria-label', 'Next image');
        } else if (!text) {
          btn.setAttribute('aria-label', 'Product images');
        }
      }
    } catch (e) {
      /* never let a11y normalization break the gallery */
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      normalize();
    };
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 16);
    }
  }

  function init() {
    normalize();
    try {
      if (typeof window.MutationObserver === 'function' && document.body) {
        var observer = new MutationObserver(function () {
          schedule();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) {
      /* observer optional; the initial normalize() still ran */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
